module.exports = __webpack_public_path__ + "static/img/22.6fc804d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/11/22.png
// module id = rT2O
// module chunks = 0